<template>
    <div>
        <loading v-if="loading"></loading>
        <div v-if="display == 'Promo'">
            <div class="box-container">
                <button
                    class="box-promo-row"
                    v-for="item in items"
                    :key="item.id"
                    @click="item.type === 'file' ? Download(item) : OpenFolder(item)">
                    <div style="white-space: nowrap">
                        <div class="box-promo-thumbnail">
                            <div
                                v-if="IsImageFile(item) && GetThumbnailSrc(item)"
                                class="sharepoint-thumbnail sharepoint-thumbnail-clickable"
                                @click.stop="PreviewImage(item)">
                                <img :src="GetThumbnailSrc(item)" :alt="item.name" />
                            </div>
                            <div v-else-if="IsVideoFile(item) && GetThumbnailSrc(item)" class="sharepoint-thumbnail">
                                <img :src="GetThumbnailSrc(item)" :alt="item.name" />
                            </div>
                            <o-icon icon="file-pdf" size="medium" v-else-if="IsPdfFile(item)"></o-icon>
                            <o-icon icon="file" size="medium" v-else-if="item.type === 'file'"></o-icon>
                            <o-icon icon="folder" size="medium" v-if="item.type === 'folder'"></o-icon>
                        </div>
                    </div>
                    <div class="box-promo-filename">
                        <div>
                            <h4>{{ item.name }}</h4>
                        </div>
                    </div>
                    <div class="box-promo-download">
                        <o-icon v-if="item.type === 'file'" icon="arrow-to-bottom"></o-icon>
                        <o-icon v-if="item.type === 'folder'" icon="folder-open"></o-icon>
                    </div>
                </button>
            </div>
        </div>

        <div v-if="display == 'Table'" class="box-table">
            <o-table :data="items" :defaultSort="['Id', 'desc']" hoverable @click="OnRowClick">
                <o-table-column field="Id" label="" v-slot="props">
                    <div class="box-table-thumbnail">
                        <div
                            v-if="IsImageFile(props.row) && GetThumbnailSrc(props.row)"
                            class="sharepoint-thumbnail sharepoint-thumbnail-clickable"
                            @click.stop="PreviewImage(props.row)">
                            <img :src="GetThumbnailSrc(props.row)" :alt="props.row.name" />
                        </div>
                        <div v-else-if="IsVideoFile(props.row) && GetThumbnailSrc(props.row)" class="sharepoint-thumbnail">
                            <img :src="GetThumbnailSrc(props.row)" :alt="props.row.name" />
                        </div>
                        <o-icon icon="file-pdf" size="medium" v-else-if="IsPdfFile(props.row)"></o-icon>
                        <o-icon icon="file" size="medium" v-else-if="props.row.type === 'file'"></o-icon>
                        <o-icon icon="folder" size="medium" v-if="props.row.type === 'folder'"></o-icon>
                    </div>
                </o-table-column>
                <o-table-column field="name" label="File Name" sortable v-slot="props">
                    <div class="box-table-row">
                        {{ props.row.name }}
                    </div>
                </o-table-column>
                <o-table-column field="modified_by.name" label="Last Modified By" sortable v-slot="props">
                    {{ GetModifiedBy(props.row) }} on
                    {{ GetModifiedAt(props.row) }}
                </o-table-column>
                <o-table-column field="" label="" v-slot="props">
                    <div class="box-table-download">
                        <o-button
                            variant="primary"
                            class="is-light"
                            @click.stop="Download(props.row)"
                            v-if="props.row.type === 'file'">
                            <o-icon icon="arrow-to-bottom"></o-icon>
                        </o-button>
                        <o-button
                            variant="primary"
                            class="is-light"
                            @click.stop="OpenFolder(props.row)"
                            v-if="props.row.type === 'folder'">
                            <o-icon icon="folder-open"></o-icon>
                        </o-button>
                    </div>
                </o-table-column>
            </o-table>
        </div>
    </div>
</template>
<script>
import { ref, inject, computed, onMounted } from "vue";
import sharepointFilesModal from "@/components/modals/sharepointFilesModal.vue";
import sharepointImagePreviewModal from "@/components/modals/sharepointImagePreviewModal.vue";

export default {
    props: {
        folderPath: {
            type: String,
            default: ""
        },
        sort: {
            type: String,
            default: null
        },
        direction: {
            type: [String, Number, Boolean],
            default: null
        },
        limit: {
            type: [String, Number],
            default: null
        },
        display: {
            type: String,
            default: "Promo"
        }
    },
    setup(props) {
        const http = inject("$http");
        const moment = inject("$moment");
        const oruga = inject("$oruga");

        const loading = ref(false);
        const items = ref([]);

        const queryString = computed(() => {
            const direction =
                props.direction === true ||
                props.direction === 1 ||
                props.direction === "true" ||
                props.direction === "1";
            const qs = [
                { key: "sort", val: props.sort },
                { key: "direction", val: direction ? "1" : "0" },
                { key: "limit", val: props.limit }
            ]
                .filter((x) => x.val || x.val === 0)
                .map((x) => x.key + "=" + x.val);
            if (qs.length > 0) {
                return "?" + qs.join("&");
            } else {
                return "";
            }
        });

        const BuildFolderUrl = (path) => {
            const normalizedPath = (path || "").replace(/^\/+|\/+$/g, "");
            let url = "/api/v2/sharepoint/folder";
            if (normalizedPath) {
                url += "?path=" + encodeURIComponent(normalizedPath);
            }

            if (!queryString.value) {
                return url;
            }

            return url + (url.indexOf("?") > -1 ? "&" : "?") + queryString.value.substring(1);
        };

        const GetFolder = async () => {
            try {
                loading.value = true;
                const response = await http.get(BuildFolderUrl(props.folderPath));
                items.value = response.data.entries;
                loading.value = false;
            } catch (err) {
                console.error(err);
                loading.value = false;
            }
        };

        const Download = async (row) => {
            try {
                const response = await http.get(
                    "/api/v2/sharepoint/file/download?path=" + encodeURIComponent(row.path || row.id),
                    {
                        responseType: "blob"
                    }
                );

                const blob = response.data;
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", row.name);

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (err) {
                console.error(err);
            }
        };

        const GetExtension = (row) => {
            return (row?.name || "").split(".").pop().toLowerCase();
        };

        const IsImageFile = (row) => {
            return row?.type === "file" && ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"].includes(GetExtension(row));
        };

        const IsVideoFile = (row) => {
            return row?.type === "file" && ["mp4", "mov", "m4v", "webm", "avi", "wmv"].includes(GetExtension(row));
        };

        const IsPdfFile = (row) => {
            return row?.type === "file" && GetExtension(row) === "pdf";
        };

        const GetThumbnailSrc = (row) => {
            return row?.thumbnail_url || "";
        };

        const GetPreviewSrc = (row) => {
            return row?.preview_url || row?.thumbnail_url || "";
        };

        const PreviewImage = (row) => {
            const src = GetPreviewSrc(row);
            if (!IsImageFile(row) || !src) {
                return;
            }

            oruga.modal.open({
                props: {
                    title: row.name,
                    src
                },
                component: sharepointImagePreviewModal,
                trapFocus: true
            });
        };

        const OpenFolder = (row) => {
            oruga.modal.open({
                props: {
                    title: row.name,
                    folderPath: row.path || row.id,
                    sort: props.sort,
                    direction: props.direction,
                    limit: props.limit
                },
                component: sharepointFilesModal,
                trapFocus: true
            });
        };

        const GetModifiedBy = (row) => {
            return row?.modified_by?.name || "Unknown";
        };

        const GetModifiedAt = (row) => {
            if (!row?.modified_at) {
                return "-";
            }
            return moment(row.modified_at).format("MM/DD/YYYY h:mm");
        };

        const OnRowClick = (row) => {
            row.type === "file" ? Download(row) : OpenFolder(row);
        };

        onMounted(() => {
            GetFolder();
        });

        return {
            loading,
            items,
            Download,
            OpenFolder,
            OnRowClick,
            GetThumbnailSrc,
            GetPreviewSrc,
            IsImageFile,
            IsVideoFile,
            IsPdfFile,
            PreviewImage,
            GetModifiedBy,
            GetModifiedAt
        };
    }
};
</script>

<style lang="scss" scoped>
@use "sass:color";
	@use "@/assets/css/globalVars.scss" as *;
.box-table {
    width: 100%;
}
.box-promo-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    border-radius: $radius-small;
    width: 100%;
    background-color: transparent;
    text-align: left;

    &:not(:last-child) {
        margin-bottom: $margin-element-medium;
    }

    &:hover {
        cursor: pointer;
        background-color: $boyden-blue-lighter;

        & .box-promo-download {
            background-color: color.adjust($boyden-blue-lighter, $lightness: 3%);
        }
        & .box-promo-thumbnail {
            background-color: color.adjust($boyden-blue-lighter, $lightness: 3%);
        }
    }
}
.box-promo-thumbnail {
    background: $boyden-blue-lighter;
    margin-top: $margin-element-tiny;
    margin-bottom: $margin-element-tiny;
    border-radius: $radius-medium;
    height: pxUnits(60);
    width: pxUnits(60);
    padding: 0;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.sharepoint-thumbnail {
    width: 100%;
    height: 100%;
    border-radius: $radius-medium;
    object-fit: cover;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
}

.sharepoint-thumbnail-clickable {
    border: none;
    padding: 0;
    cursor: pointer;
}

.box-promo-filename {
    flex-grow: 2;
    display: flex;
}

.box-promo-download {
    border-radius: $radius-small;
    width: pxUnits(40);
    min-width: pxUnits(40);
    height: pxUnits(40);
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $boyden-blue-lighter;
    color: $boyden-blue;
    font-size: 1.4rem;
}

.box-table-row {
    & > td {
        padding-top: 12px;
    }
}
.box-table-thumbnail {
    height: 35px;
    width: 35px;
    margin-right: -10px;
    display: flex;
    align-items: center;

    .sharepoint-thumbnail {
        width: 35px;
        height: 35px;
        border-radius: 4px;
    }
}

.box-table-filename {
    flex-grow: 2;
    display: flex;
    align-items: center;
}
.box-table-download {
    align-items: right;
    justify-content: right;
    float: right;
    background-color: $boyden-blue-lighter;
    color: $boyden-blue;

    &:hover {
        background-color: $boyden-blue-lighter !important;
    }
}
.box-table {
    margin-top: 10px;
    margin-bottom: 10px;
    td {
        padding-top: 12px;
    }

    &:hover {
        cursor: pointer;
        background-color: $boyden-blue-lighter;

        & .box-table-download {
            background-color: color.adjust($boyden-blue-lighter, $lightness: 3%);
        }
    }
}
</style>
